import React, { useState } from "react";
import { Filter } from "lucide-react";
import FilterBar from "./FilterBar";
import FilterPills from "./FilterPills";

/**
 * Reusable header + filters section for post-analysis tabs.
 *
 * Props:
 * - title: string
 * - subtitle?: string
 * - filters: current filter object
 * - setFilters: setter for filters
 * - baseFilterOptions: options coming from the main data hook
 * - localFilterOptions: locally refined options (from usePostAnalysisFilters)
 * - handleLocalFiltersChange: fn(localFilters) -> void|Promise
 */
export default function PostAnalysisHeaderWithFilters({
  title,
  subtitle,
  filters,
  setFilters,
  baseFilterOptions,
  localFilterOptions,
  handleLocalFiltersChange,
}) {
  const [showFilters, setShowFilters] = useState(false);

  const handleClearAll = () => {
    setFilters({
      brand: "",
      region: "",
      campaign: [],
      start_date: "",
      end_date: "",
      poc_id: [],
      poc_name: [],
      key_account: "",
    });
  };

  return (
    <>
      {/* Header with filter icon at right */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold text-foreground">{title}</h1>
          {subtitle && (
            <p className="text-muted-foreground">
              {subtitle}
            </p>
          )}
        </div>
        <button
          onClick={() => setShowFilters((v) => !v)}
          className={`flex items-center gap-1 text-primary hover:text-primary/80${
            showFilters ? " font-bold" : ""
          }`}
        >
          <Filter className="h-5 w-5" /> Filters
        </button>
      </div>

      {/* FilterBar below the header, controlled by showFilters */}
      {showFilters && (
        <FilterBar
          filters={filters}
          setFilters={setFilters}
          filterOptions={localFilterOptions || baseFilterOptions || {}}
          onLocalFiltersChange={handleLocalFiltersChange}
        />
      )}

      {/* FilterPills always below the FilterBar or header */}
      <FilterPills
        filters={filters}
        setFilters={setFilters}
        clearAll={handleClearAll}
        filterOptions={baseFilterOptions || {}}
      />
    </>
  );
}

